<div class="row" style="width:100%;margin:0 auto;">
    <div class="col-12">
        <mdb-card>
            <mdb-card-header class="bg-white ">
                <div class="headerCover">
                    <div class="headerTilte app_list_header">
                        <h5 class="m-0" class="mainHeadingStyle">Package List</h5>
                    </div>
                    <div class="headerButtons">
                        <div *ngIf="createFlag"><a (click)="create()"><img src="../../../assets/ui_icons/buttons/new_button.svg"
                                    class="saveimgbtn_inpatinfo"></a></div>
                    </div>
                </div>
            </mdb-card-header>
            <mdb-card-body>
                <div class="row" style="margin-top: 15px;">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <p class="nodata" *ngIf="packageListArray.length == 0">No package(s) found</p>
                        <table *ngIf="packageListArray.length != 0" mdbTable datatable [dtOptions]="dtOptions" class="table table-nowrap table-sm dataTable billlisttable">
                            <thead>
                                <tr>
                                    <th>SI.NO</th>
                                    <th>Icons</th>
                                    <th>Package name</th>
                                    <th>Package type</th>
                                    <th>Price</th>
                                    <th class="delete">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let package of packageListArray; let i = index"  (click)="viewPackage(package)">
                                    <td style="font-size: 12px;text-align: center;">
                                        {{i + 1}}
                                    </td>
                                    <td style="font-size: 12px;text-align: center;">
                                        <img [src]="package.image" height="25px" width="25px" alt=""> 
                                    </td>
                                    <td style="font-size: 12px;text-align: center;">
                                        {{package.package_name}}
                                    </td>
                                    <td style="font-size: 12px;text-align: center;">
                                        {{package.package_type_desc}}
                                    </td>
                                    <td style="font-size: 12px;text-align: center;">
                                        {{package.price}}
                                    </td>
                                    <td *ngIf="editFlag" style="font-size: 12px;text-align: center;">
                                        <img src="../../../assets/img/edit.png" class="billing_edit" style="width: 20px; height: 20px;" alt="" (click)="editPackage(package)">
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </mdb-card-body>
        </mdb-card>
    </div>
</div>